const RiskLevel = Object.freeze({
  LOW: 'Low',
  HIGH: 'High',
});

const NewRiskLevel = Object.freeze({
  MEDIUM: { value: 'Medium', label: 'Medium' },
  HIGHER: { value: 'High', label: 'Higher' },
  LOWER: { value: 'Low', label: 'Lower' },
  SAME: { value: 'Same', label: 'Same' },
});

export { RiskLevel, NewRiskLevel };
